// Auto-generated skeleton for Comment

import { User } from "./User";
import { SourceResource } from "./SourceResource";

export const Comment: Api.Comment = {
  id: 0,
  author_user_id: 0,
  author: User,
  comment: '',
  is_internal: false,
  source: SourceResource,
  comments: [],
  readconfirmations: [],
  emails: [],
  created: null,
  updated: null,
};

